<img src="./assets/img/notfound.svg" />
<div style="display: flex; justify-content: center;">
    <button [routerLink]="['/dashboard']" matTooltip="Dashboard" type="button" mat-raised-button style="background-color: #252c61; color: white;">Go to DashBoard</button>
</div>